// src/personel-takip/src/pages/PuantajPage.js
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  collection, doc, getDoc, getDocs, query, setDoc, where,
  updateDoc, arrayUnion, arrayRemove, writeBatch, addDoc
} from "firebase/firestore";
import { db, auth } from "../firebaseConfig";
import * as XLSX from "xlsx";
import Select from "react-select";

/* ---------- helpers (basit) ---------- */
const pad2 = (n) => String(n).padStart(2, "0");
const daysInMonth = (y, m) => new Date(y, m, 0).getDate();
const ymLabel = (y, m) => new Date(y, m - 1, 1).toLocaleDateString("tr-TR", { year: "numeric", month: "long" });
const range = (n) => Array.from({ length: n }, (_, i) => i + 1);
const toISO = (y, m, d) => `${y}-${pad2(m)}-${pad2(d)}`;
const ymmm = (y, m) => `${y}${pad2(m)}`;
const incYM = (y, m) => { m += 1; if (m > 12) { y++; m = 1; } return [y, m]; };
const decYM = (y, m) => { m -= 1; if (m < 1) { y--; m = 12; } return [y, m]; };
const isSunday = (y, m, d) => new Date(y, m - 1, d).getDay() === 0;
const toDayNumber = (v) => {
  const n = Number(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) && n > 0 ? n : 0;
};
const normText = (v) => String(v ?? "").toLocaleLowerCase("tr-TR").trim();
const compareNumeric = (value, op, rawTarget) => {
  if (!op || rawTarget === "" || rawTarget == null) return true;
  const target = Number(String(rawTarget).replace(",", "."));
  if (!Number.isFinite(target)) return true;
  const n = Number(value) || 0;
  if (op === ">") return n > target;
  if (op === ">=") return n >= target;
  if (op === "<") return n < target;
  if (op === "<=") return n <= target;
  if (op === "=") return n === target;
  return true;
};

const parseDotOrISO = (v) => {
  if (!v) return null;
  if (v.toDate) return v.toDate();
  const s = String(v);
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return new Date(s);
  const s2 = s.replaceAll("/", ".").replaceAll("-", ".");
  const m = s2.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
  if (!m) return null;
  return new Date(+m[3], +m[2] - 1, +m[1]);
};

/* ---- stat?ler ---- */
const ORDER = ["CALISMA", "IZIN", "MAHSUP", "UCRETSIZ", "RAPOR", "RESMI_TATIL", "YILLIK"];
const SHORT = { CALISMA: "C", IZIN: "İ", MAHSUP: "M", UCRETSIZ: "Ü", RAPOR: "R", RESMI_TATIL: "T", YILLIK: "Y", NA: "×" };
const TITLE = {
  CALISMA: "Çalışma",
  IZIN: "İzin",
  MAHSUP: "Mahsup",
  UCRETSIZ: "Ücretsiz İzin",
  RAPOR: "Rapor",
  RESMI_TATIL: "Resmî Tatil",
  YILLIK: "Yıllık İzin",
  NA: "Aktif değil",
};

// ğŸ�?�? T art?k d?ng?de (tıklamayla T seçilebilsin)
const ORDER_CLICK = ["CALISMA", "IZIN", "UCRETSIZ", "RAPOR", "RESMI_TATIL", "YILLIK"];
const nextStatusClick = (s) => {
  const i = ORDER_CLICK.indexOf(s);
  if (i === -1) return ORDER_CLICK[0];
  return ORDER_CLICK[(i + 1) % ORDER_CLICK.length];
};

/* ---- istihdam aral?klar? & aktiflik ---- */
const getIntervals = (tarih = {}) => {
  const g = [], c = [];
  for (const [k, v] of Object.entries(tarih)) {
    if (!v) continue;
    if (k.startsWith("giris")) g.push([k, parseDotOrISO(v)]);
    if (k.startsWith("cikis")) c.push([k, parseDotOrISO(v)]);
  }
  const num = (s) => +(s.match(/\d+/)?.[0] || 0);
  g.sort((a, b) => num(a[0]) - num(b[0]));
  c.sort((a, b) => num(a[0]) - num(b[0]));
  const out = [];
  for (let i = 0; i < g.length; i++) {
    const start = g[i][1];
    const end = c[i]?.[1] || null;
    if (start) out.push([start, end]);
  }
  return out;
};
const isActiveOnDate = (tarih = {}, y, m, d) => {
  const ivs = getIntervals(tarih);
  const dt = new Date(y, m - 1, d);
  return ivs.some(([s, e]) => {
    const end = e ? new Date(e.getFullYear(), e.getMonth(), e.getDate() + 1) : null;
    return (s <= dt) && (!end || end > dt);
  });
};
const lastGirisDate = (tarih = {}) => {
  const gir = Object.entries(tarih).filter(([k]) => k.startsWith("giris"));
  if (!gir.length) return null;
  gir.sort(([a], [b]) => a.localeCompare(b));
  return parseDotOrISO(gir[gir.length - 1][1]);
};

/* ---- y?ll?k hak (toplam/ kalan) ---- */
/* ---- y?ll?k hak (toplam/ kalan) ---- */
const fullYearsWorked = (p, refDate) => {
  const inDate = lastGirisDate(p.tarih || {}) || refDate;
  const start = new Date(inDate.getFullYear(), inDate.getMonth(), inDate.getDate());
  const ref = new Date(refDate.getFullYear(), refDate.getMonth(), refDate.getDate());
  const diffMs = ref - start;
  return Math.max(0, Math.floor(diffMs / (1000 * 60 * 60 * 24 * 365.25)));
};

// 60+ emekli ise y?ll?k izin baz hakk? 20 gün; aksi halde 14 gün
const isEmekli60Plus = (p, refDate) => {
  const sgk = (p.sgkDurumu || "").toLocaleUpperCase("tr-TR");
  const isEmekli = sgk.includes("EMEKL");
  const dob = (p.dogumTarihi || "").trim();
  const dobDate = dob ? parseDotOrISO(dob) : null; // "1950-07-06" veya "06.07.1950" ikisini de okur
  if (!isEmekli || !dobDate) return false;
  const age = Math.floor((refDate - dobDate) / (1000 * 60 * 60 * 24 * 365.25));
  return age >= 60;
};

const annualBasePerYear = (p, refDate) => (isEmekli60Plus(p, refDate) ? 20 : 14);

// Toplam biriken y?ll?k hak (basit model: her tam y?l için baz gün)
const defaultAccruedAnnual = (p, refDate) => fullYearsWorked(p, refDate) * annualBasePerYear(p, refDate);


/* =======================================
   B?LEÅ�?EN
======================================= */
const PuantajPage = () => {
  const today = new Date();
  const [year, setYear] = useState(today.getFullYear());
  const [month, setMonth] = useState(today.getMonth() + 1);
  const yyyymm = ymmm(year, month);
  const dom = daysInMonth(year, month);
  const days = useMemo(() => range(dom), [dom]);

  const [showNotes, setShowNotes] = useState(false);
  const [includePassive, setIncludePassive] = useState(false);
  const [personsLoading, setPersonsLoading] = useState(false);

  const [persons, setPersons] = useState([]);
  const [cells, setCells] = useState({}); // sadece görünür ay?n h?creleri
  const [allByPidDate, setAllByPidDate] = useState({}); // Tüm puantaj (pid->iso->status)

  // Resm? tatil kay?tlar? (koleksiyon)
  const [yearDays, setYearDays] = useState([]);      // bu yılın ISO tarih listesi
  const [holidayNotes, setHolidayNotes] = useState({}); // iso -> note
  const [holidayApplyMap, setHolidayApplyMap] = useState({}); // iso -> boolean

  const curUser = auth?.currentUser || null;

  /* ---------- Roller (Navbar mant') ---------- */
  const [isCreator, setIsCreator] = useState(false);
  const [isAdminModule, setIsAdminModule] = useState(false);
  const [isHR, setIsHR] = useState(false);
  const [isSiteManager, setIsSiteManager] = useState(false);
  const [isForeman, setIsForeman] = useState(false);

  const [allowedTesis, setAllowedTesis] = useState([]);
  const [selectedTesis, setSelectedTesis] = useState(""); // Kullan?c?n?n seçti?i filtre
  const [search, setSearch] = useState(""); // ğŸ‘ˆ Hata veren de?i?kenler bunlar, ?imdi tan?mlad?k
  const [tableSort, setTableSort] = useState({ key: null, dir: null });
  const [tableFilters, setTableFilters] = useState({
    personel: "",
    personelValues: [],
    annualOp: "",
    annualValue: "",
    annualKalanOp: "",
    annualKalanValue: "",
    hakOp: "",
    hakValue: "",
    hakKalanOp: "",
    hakKalanValue: "",
    usedOp: "",
    usedValue: "",
    usedMonthOp: "",
    usedMonthValue: "",
    mahsupOp: "",
    mahsupValue: "",
    kesintiOp: "",
    kesintiValue: "",
  });
  const [openTableFilter, setOpenTableFilter] = useState(null);
  const [filterMenuPos, setFilterMenuPos] = useState(null);
  const [, setFilterSearch] = useState("");
  const tableFilterMenuRef = useRef(null);

  const [canSeeOps, setCanSeeOps] = useState(false); // (art?k RT paneli için a?a??daki rol seti kullan?lacak)
  const [canAdmin, setCanAdmin] = useState(false);

  const [annualOverrideMap, setAnnualOverrideMap] = useState({});
  const [balanceMovements, setBalanceMovements] = useState({});
  const [openBalanceModalFor, setOpenBalanceModalFor] = useState(null);
  const [balanceMahsupValue, setBalanceMahsupValue] = useState("");
  const [balanceKesintiValue, setBalanceKesintiValue] = useState("");
  const [balanceNote, setBalanceNote] = useState("");
  const balanceMahsupRef = useRef(null);
  const balanceKesintiRef = useRef(null);
  const balanceNoteRef = useRef(null);

  const canSpecialPuantaj = isCreator || isAdminModule || isHR || isSiteManager;
  const [annualUsedAllTime, setAnnualUsedAllTime] = useState({}); // YILLIK kullan?m? (t?m zaman)

  useEffect(() => {
    const closeOnOutside = (event) => {
      if (tableFilterMenuRef.current && !tableFilterMenuRef.current.contains(event.target)) {
        setOpenTableFilter(null);
        setFilterMenuPos(null);
      }
    };
    document.addEventListener("mousedown", closeOnOutside);
    return () => document.removeEventListener("mousedown", closeOnOutside);
  }, []);

  /* ------------ YETK? / TES?S ------------ */
  useEffect(() => {
    (async () => {
      try {
        const emailLc = curUser?.email?.toLowerCase();
        if (!emailLc) {
          setAllowedTesis([]);
          setCanSeeOps(false);
          setCanAdmin(false);
          setIsCreator(false);
          setIsAdminModule(false);
          setIsHR(false);
          setIsSiteManager(false);
          setIsForeman(false);
          return;
        }

        // kişi hangi tesisi g?rebilir
        const qP = query(collection(db, "personeller"), where("email", "==", emailLc));
        const sP = await getDocs(qP);
        const own = new Set();
        if (!sP.empty) {
          sP.forEach(d => {
            const data = d.data() || {};
            if (data.tesis) own.add(String(data.tesis).toUpperCase());
            let extra = data.gorebilecegiTesisler;
            if (typeof extra === "string") extra = extra.split(",").map(x=>x.trim()).filter(Boolean);
            (extra || []).forEach(t => own.add(String(t).toUpperCase()));
          });
        }
        setAllowedTesis(Array.from(own));

        // users.personeltakip ile rol ??kar?m? (Navbar kural?)
        const qU = query(collection(db, "users"), where("email", "==", emailLc));
        const sU = await getDocs(qU);
        let pt = {};
        let roleStr = "";
        sU.forEach(d => {
          const u = d.data() || {};
          roleStr = (u.role || "").toString().toLowerCase();
          pt = u.personeltakip || {};
        });

        const giris = pt.giris === true;
        const takip = pt.takip === true;
        const yonetici = pt.yonetici === true;
        const creator = pt.creator === true || roleStr === "creator";

        setIsCreator(!!creator);
        setIsAdminModule(!!yonetici);
        setIsHR(!!(giris && takip));        // ?K
        setIsSiteManager(!!(!giris && takip)); // Saha Y?neticisi
        setIsForeman(!!(giris && !takip));  // Formen

        // Eski bayraklar (varsa) - ba?ka yer kullan?yorsa bozmayal?m
        let see = false, admin = false;
        if (giris === true && takip === true) see = true;
        if (giris === true && takip === true && yonetici === true) admin = true;
        setCanSeeOps(see);
        setCanAdmin(admin);

      } catch {
        setAllowedTesis([]);
        setCanSeeOps(false);
        setCanAdmin(false);
        setIsCreator(false);
        setIsAdminModule(false);
        setIsHR(false);
        setIsSiteManager(false);
        setIsForeman(false);
      }
    })();
  }, [curUser?.email]);


/* ------------ PERSONELLER ------------ */
  useEffect(() => {
    let alive = true;
    (async () => {
      setPersonsLoading(true);
      try {
        const snap = await getDocs(collection(db, "personeller"));
        let arr = snap.docs.map((d) => ({ id: d.id, ...d.data() }));

        const setT = new Set(allowedTesis.map((t) => String(t).toUpperCase()));
        arr = arr.filter((p) => setT.has(String(p.tesis || "").toUpperCase()));

        if (selectedTesis) {
          arr = arr.filter((p) => String(p.tesis || "").toUpperCase() === selectedTesis.toUpperCase());
        }

        const filtered = arr.filter((p) => {
          if (includePassive) return true;
          for (let d = 1; d <= dom; d++) {
            if (isActiveOnDate(p.tarih || {}, year, month, d)) return true;
          }
          return false;
        });

        filtered.sort((a, b) =>
          (a.ad || "").localeCompare(b.ad || "", "tr", { sensitivity: "base" }) ||
          (a.soyad || "").localeCompare(b.soyad || "", "tr", { sensitivity: "base" })
        );
        if (alive) setPersons(filtered);
      } finally {
        if (alive) setPersonsLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [includePassive, allowedTesis, year, month, dom, selectedTesis]);

  /* ------------ G?R?NEN AYIN H?CRELER? ------------ */
  useEffect(() => {
    (async () => {
      const qref = query(collection(db, "puantajV2"), where("yyyymm", "==", yyyymm));
      const snap = await getDocs(qref);
      const map = {};
      snap.forEach((d) => {
        const v = d.data() || {};
        const pid = v.personelId;
        const ym = v.yyyymm;
        const dateStr = String(v.date || "");
        const dd = dateStr.slice(-2);
        if (pid && ym && /^\d{2}$/.test(dd)) {
          map[`${pid}_${ym}${pad2(dd)}`] = { status: v.status, note: v.note || "" };
        } else {
          map[d.id] = { status: v.status, note: v.note || "" };
        }
      });
      setCells(map);
    })();
  }, [yyyymm]);

  /* ------------ T?M PUANTAJ ?NDEKS? (kullan?m? sade) ------------ */
  useEffect(() => {
    (async () => {
      const qref = query(
        collection(db, "puantajV2"),
        where("yyyymm", ">=", `200001`),
        where("yyyymm", "<=", yyyymm)
      );
      const snap = await getDocs(qref);
      const byPid = {};
      const annual = {};
      snap.forEach((d) => {
        const v = d.data() || {};
        const pid = v.personelId;
        const iso = v.date;
        if (!pid || !iso) return;
        if (!byPid[pid]) byPid[pid] = {};
        byPid[pid][iso] = v.status;

        if (v.status === "YILLIK") annual[pid] = (annual[pid] || 0) + 1;
      });
      setAllByPidDate(byPid);
      setAnnualUsedAllTime(annual);
    })();
  }, [yyyymm]);

  /* ------------ RESMÃ�? TAT?LLER (koleksiyon) ------------ */
  const readHolidays = async () => {
    const h = await getDoc(doc(db, "resmiTatil", String(year)));
    const list = h.exists() ? (h.data().days || []) : [];
    const notes = h.exists() ? (h.data().notes || {}) : {};
    const applyMap = h.exists() ? (h.data().apply || {}) : {};
    setYearDays(list);
    setHolidayNotes(notes || {});
    setHolidayApplyMap(applyMap || {});
  };
  useEffect(() => { (async () => { await readHolidays(); })(); /* eslint-disable-next-line */ }, [year]);

  /* ------------ YILLIK OVERRIDE OKUMA ------------ */
  useEffect(() => {
    (async () => {
      const snap = await getDocs(collection(db, "izinAyar"));
      const m = {};
      snap.forEach(d => {
        const v = d.data() || {};
        if (typeof v.annualOverride === "number") m[d.id] = v.annualOverride;
      });
      setAnnualOverrideMap(m);
    })();
  }, []);

  /* ------------ MAHSUP / KESINTI MAHSUBU OKUMA ------------ */
  useEffect(() => {
    (async () => {
      const qref = query(
        collection(db, "puantajBakiyeHareketleri"),
        where("yyyymm", ">=", "200001"),
        where("yyyymm", "<=", yyyymm)
      );
      const snap = await getDocs(qref);
      const map = {};
      snap.forEach((d) => {
        const v = d.data() || {};
        const pid = v.personelId;
        const ym = String(v.yyyymm || "");
        if (!pid || !ym) return;
        if (!map[pid]) map[pid] = {};
        map[pid][ym] = {
          mahsupGun: toDayNumber(v.mahsupGun),
          kesintiGun: toDayNumber(v.kesintiGun),
          note: v.note || "",
        };
      });
      setBalanceMovements(map);
    })();
  }, [yyyymm]);

  /* ------------ YAZMA / TOGGLE / NOT ------------ */
  const curUserRef = () => (curUser ? { uid: curUser.uid, email: curUser.email || "-" } : { uid: "-", email: "-" });

  const writeCell = async (pid, d, patch, y = year, m = month) => {
    const ym = ymmm(y, m);
    const key = `${pid}_${ym}${pad2(d)}`;
    const iso = toISO(y, m, d);

    const next = {
      personelId: pid,
      date: iso,
      yyyymm: ym,
      status: "CALISMA",
      note: "",
      enteredBy: curUserRef(),
      enteredAt: new Date(),
      ...patch,
    };
    await setDoc(doc(db, "puantajV2", key), next, { merge: true });

    // görünür ay state
    setCells((mmap) => ({ ...mmap, [key]: { status: next.status, note: next.note || "" } }));
    // global indeks
    setAllByPidDate((mm) => {
      const n = { ...mm };
      if (!n[pid]) n[pid] = {};
      n[pid][iso] = next.status;
      return n;
    });

    // y?ll?k saya? (sade)
    setAnnualUsedAllTime((mm) => {
      const was = cells[key]?.status;
      const cur = { ...mm };
      const wasY = was === "YILLIK";
      const isY = next.status === "YILLIK";
      if (wasY && !isY) cur[pid] = Math.max(0, (cur[pid] || 0) - 1);
      else if (!wasY && isY) cur[pid] = (cur[pid] || 0) + 1;
      return cur;
    });
  };

  // ----------- Tarih düzenleme yetkisi (rol + 3 gün ge?mi? / 7 gün gelecek kural?) -----------
  const canEditDate = (y, m, d) => {
    // Tam yetki: Creator / Mod?l Admini / ?K / Saha Y?neticisi
    if (isCreator || isAdminModule || isHR || isSiteManager) return true;

    // Di?er herkes: son 3 gün ve gelecek 7 gün (bugün=0, d?n=1, yar?n=-1)
    const today0 = new Date();
    const T0 = new Date(today0.getFullYear(), today0.getMonth(), today0.getDate());
    const Dt = new Date(y, m - 1, d);
    const diffDays = Math.floor((T0 - Dt) / (1000 * 60 * 60 * 24));
    return diffDays <= 2 && diffDays >= -7;
  };

  const toggleCell = async (pid, d, pObj) => {
    if (!isActiveOnDate(pObj.tarih || {}, year, month, d)) return;

    if (!canEditDate(year, month, d)) {
      alert("Bu gün? düzenleme yetkiniz yok.");
      return;
    }

    const key = `${pid}_${yyyymm}${pad2(d)}`;
    const iso = toISO(year, month, d);

    // Etkin stat? (tatil uygulamas? varsa T, aksi halde kay?t ya da C)
    const effective = cells[key]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA");

    // Art?k T (Resmî Tatil) tıklama d?ng?s?nde - kilit yok.
    const ns = nextStatusClick(effective);
    await writeCell(pid, d, { status: ns });
  };

  const noteDraft = useRef({});
  const noteTimers = useRef({});
  const onNoteChange = (pid, d, val) => {
    const key = `${pid}_${yyyymm}${pad2(d)}`;
    const iso = toISO(year, month, d);
    noteDraft.current[key] = val;
    setCells((m) => ({ ...m, [key]: { status: (m[key]?.status || "CALISMA"), note: val } }));
    if (noteTimers.current[key]) clearTimeout(noteTimers.current[key]);
    noteTimers.current[key] = setTimeout(() => {
      setDoc(doc(db, "puantajV2", key), {
        personelId: pid,
        date: iso,
        yyyymm: yyyymm,
        note: noteDraft.current[key] || "",
        enteredBy: curUserRef(),
        enteredAt: new Date(),
      }, { merge: true });
      delete noteTimers.current[key];
    }, 500);
  };

  /* =======================================
     KURALLARA G?RE SAYIM
     Hak/Kalan ve Kullanılanlar
     (HAK stabil: Pazar + RT (aktif gün), h?cre stat?s?nden ba??ms?z)
  ======================================= */
  const eachDate = (sy, sm, ey, em, fn) => {
    let y = sy, m = sm;
    while (y < ey || (y === ey && m <= em)) {
      const domM = daysInMonth(y, m);
      for (let d = 1; d <= domM; d++) fn(y, m, d);
      [y, m] = incYM(y, m);
    }
  };

  const getBalanceMovementForMonth = (pid, ym = yyyymm) => (
    balanceMovements[pid]?.[ym] || { mahsupGun: 0, kesintiGun: 0, note: "" }
  );

  const getBalanceMovementTotals = (pid, untilYm = yyyymm) => {
    const months = balanceMovements[pid] || {};
    return Object.entries(months).reduce((acc, [ym, v]) => {
      if (String(ym) <= String(untilYm)) {
        acc.mahsupGun += toDayNumber(v.mahsupGun);
        acc.kesintiGun += toDayNumber(v.kesintiGun);
      }
      return acc;
    }, { mahsupGun: 0, kesintiGun: 0 });
  };

  const applyBalanceMovements = (rawKalan, pid, untilYm = yyyymm) => {
    const totals = getBalanceMovementTotals(pid, untilYm);
    const effectiveMahsup = Math.min(totals.mahsupGun, Math.max(0, rawKalan));
    const afterMahsup = rawKalan - effectiveMahsup;
    const effectiveKesinti = Math.min(totals.kesintiGun, Math.max(0, -afterMahsup));
    return {
      rawKalan,
      mahsupGun: totals.mahsupGun,
      kesintiGun: totals.kesintiGun,
      effectiveMahsup,
      effectiveKesinti,
      fazlaMahsup: Math.max(0, totals.mahsupGun - effectiveMahsup),
      fazlaKesinti: Math.max(0, totals.kesintiGun - effectiveKesinti),
      kalan: afterMahsup + effectiveKesinti,
    };
  };

const buildPersonCounters = (p) => {
  const gi = lastGirisDate(p.tarih || {});
  if (!gi) return {
    hak: 0,
    kalan: 0,
    rawKalan: 0,
    balance: applyBalanceMovements(0, p.id),
    usedTotal: 0,
    usedThisMonth: 0,
    counts: { C:0,I:0,M:0,Y:0,U:0,R:0,T:0 }
  };

  const startY = gi.getFullYear();
  const startM = gi.getMonth() + 1;

  const now = new Date();
  const nowY = now.getFullYear();
  const nowM = now.getMonth() + 1;
  const nowD = now.getDate();
  const isPastSelected = (year < nowY) || (year === nowY && month < nowM);

  const endY = year;
  const endM = month;

  const maxDayFor = (y, m) => {
    if (isPastSelected) return daysInMonth(y, m);
    if (y < nowY || (y === nowY && m < nowM)) return daysInMonth(y, m);
    if (y === nowY && m === nowM) return Math.min(daysInMonth(y, m), nowD);
    return 0;
  };

  // HAK: Pazarlar
  let sundays = 0;
  {
    let y = startY, m = startM;
    while (y < endY || (y === endY && m <= endM)) {
      const maxD = maxDayFor(y, m);
      for (let d = 1; d <= maxD; d++) {
        if (!isActiveOnDate(p.tarih || {}, y, m, d)) continue;
        if (isSunday(y, m, d)) sundays++;
      }
      [y, m] = incYM(y, m);
    }
  }

  // HAK: Resm? tatiller (aktif & pazar de?il; h?cre stat?s?nden ba??ms?z)
  let rtEligible = 0;
  for (const iso of yearDays) {
    const y = +iso.slice(0,4), m = +iso.slice(5,7), d = +iso.slice(8,10);
    if (y < startY || (y === startY && m < startM)) continue;
    if (y > endY || (y === endY && m > endM)) continue;
    const maxD = maxDayFor(y, m);
    if (d < 1 || d > maxD) continue;
    if (!isActiveOnDate(p.tarih || {}, y, m, d)) continue;
    if (isSunday(y, m, d)) continue;
    rtEligible++;
  }

  const hak = sundays + rtEligible;

  // --- Kullanılanlar (Toplam/Bu Ay) ---  [M?KEMMEL2 mant']
  let usedTotal = 0;
  let usedThisMonth = 0;

  eachDate(startY, startM, endY, endM, (y, m, d) => {
    const maxD = maxDayFor(y, m);
    if (d > maxD) return;
    if (!isActiveOnDate(p.tarih || {}, y, m, d)) return;
    const iso = toISO(y, m, d);
    const st =
      (y === year && m === month)
        ? (cells[`${p.id}_${yyyymm}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA"))
        : (allByPidDate[p.id]?.[iso] || "CALISMA");
    const isUsed = (st === "IZIN" || st === "MAHSUP" || st === "RESMI_TATIL");
    if (isUsed) {
      usedTotal++;
      if (y === year && m === month) usedThisMonth++;
    }
  });

  // Mevcut ay i?i da??l?m (renk/Özet için)
  let C=0, I=0, M=0, Y=0, U=0, R=0, T=0;
  for (let d = 1; d <= dom; d++) {
    if (!isActiveOnDate(p.tarih || {}, year, month, d)) continue;
    const iso = toISO(year, month, d);
    const st = cells[`${p.id}_${yyyymm}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA");
    if (st === "CALISMA") C++;
    else if (st === "IZIN") I++;
    else if (st === "MAHSUP") M++;
    else if (st === "YILLIK") Y++;
    else if (st === "UCRETSIZ") U++;
    else if (st === "RAPOR") R++;
    else if (st === "RESMI_TATIL") T++;
  }

  const rawKalan = hak - usedTotal;
  const balance = applyBalanceMovements(rawKalan, p.id);
  return { hak, kalan: balance.kalan, rawKalan, balance, usedTotal, usedThisMonth, counts: { C, I, M, Y, U, R, T } };
};


  /* ------------ K?Å�?? ?ZET? (Yıllık + tablo Üst?) ------------ */
  const personSummary = (p) => {
    const refDate = new Date(year, month - 1, daysInMonth(year, month));
    // Yıllık (toplam/ kalan)
    const override = annualOverrideMap[p.id];
    const hakkYillikToplam = Math.max(0, typeof override === "number" ? override : defaultAccruedAnnual(p, refDate));
    const usedAnnualAll = annualUsedAllTime[p.id] || 0;
    const kalanYillik = hakkYillikToplam - usedAnnualAll;

    const { hak, kalan, rawKalan, balance, usedTotal, usedThisMonth, counts } = buildPersonCounters(p);

    return {
      annual: { toplam: hakkYillikToplam, kalan: kalanYillik },
      hk: { hak, kalan, rawKalan },
      balance,
      used: { total: usedTotal, month: usedThisMonth },
      counts
    };
  };

  /* ------------ TOPLAM SATIRI ------------ */
  const topTotals = useMemo(() => {
    let C = 0, I = 0, M = 0, Y = 0, U = 0, R = 0, T = 0, BM = 0, BK = 0;
    for (const p of persons) {
      for (let d = 1; d <= dom; d++) {
        if (!isActiveOnDate(p.tarih || {}, year, month, d)) continue;
        const iso = toISO(year, month, d);
        const st = cells[`${p.id}_${yyyymm}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA");
        if (st === "CALISMA") C++;
        else if (st === "IZIN") I++;
        else if (st === "MAHSUP") M++;
        else if (st === "YILLIK") Y++;
        else if (st === "UCRETSIZ") U++;
        else if (st === "RAPOR") R++;
        else if (st === "RESMI_TATIL") T++;
      }
      const movement = getBalanceMovementForMonth(p.id);
      BM += toDayNumber(movement.mahsupGun);
      BK += toDayNumber(movement.kesintiGun);
    }
    return { C, I, M, Y, U, R, T, BM, BK };
  }, [persons, cells, year, month, dom, holidayApplyMap, balanceMovements, yyyymm]);

  const updateTableFilter = (key, value) => {
    setTableFilters((prev) => ({ ...prev, [key]: value }));
  };

  const baseTableRows = useMemo(() => {
    return persons.map((p) => {
      const s = personSummary(p);
      const currentAnnualShown =
        typeof annualOverrideMap[p.id] === "number"
          ? Math.max(0, annualOverrideMap[p.id])
          : s.annual.toplam;
      const personName = `${p.ad || ""} ${p.soyad || ""}`.trim();
      return {
        p,
        s,
        currentAnnualShown,
        personName,
        sortValues: {
          personel: personName,
          annual: currentAnnualShown,
          annualKalan: s.annual.kalan,
          hak: s.hk.hak,
          hakKalan: s.hk.kalan,
          used: s.used.total,
          usedMonth: s.used.month,
          mahsup: s.balance.mahsupGun || 0,
          kesinti: s.balance.kesintiGun || 0,
        },
      };
    });
  }, [persons, annualOverrideMap, annualUsedAllTime, balanceMovements, cells, allByPidDate, yearDays, holidayApplyMap, year, month, dom]);

  const tableRows = useMemo(() => {
    const filtered = baseTableRows.filter((row) => {
      if (tableFilters.personel && !normText(row.personName).includes(normText(tableFilters.personel))) return false;
      if (tableFilters.personelValues?.length && !tableFilters.personelValues.includes(row.personName)) return false;
      if (!compareNumeric(row.currentAnnualShown, tableFilters.annualOp, tableFilters.annualValue)) return false;
      if (!compareNumeric(row.s.annual.kalan, tableFilters.annualKalanOp, tableFilters.annualKalanValue)) return false;
      if (!compareNumeric(row.s.hk.hak, tableFilters.hakOp, tableFilters.hakValue)) return false;
      if (!compareNumeric(row.s.hk.kalan, tableFilters.hakKalanOp, tableFilters.hakKalanValue)) return false;
      if (!compareNumeric(row.s.used.total, tableFilters.usedOp, tableFilters.usedValue)) return false;
      if (!compareNumeric(row.s.used.month, tableFilters.usedMonthOp, tableFilters.usedMonthValue)) return false;
      if (!compareNumeric(row.s.balance.mahsupGun || 0, tableFilters.mahsupOp, tableFilters.mahsupValue)) return false;
      if (!compareNumeric(row.s.balance.kesintiGun || 0, tableFilters.kesintiOp, tableFilters.kesintiValue)) return false;
      return true;
    });

    if (!tableSort.key) return filtered;
    const dir = tableSort.dir === "desc" ? -1 : 1;
    return filtered.sort((a, b) => {
      const av = a.sortValues[tableSort.key];
      const bv = b.sortValues[tableSort.key];
      if (tableSort.key === "personel") {
        return String(av || "").localeCompare(String(bv || ""), "tr-TR") * dir;
      }
      return ((Number(av) || 0) - (Number(bv) || 0)) * dir;
    });
  }, [baseTableRows, tableFilters, tableSort]);

  const toggleHeaderFilter = (key, e) => {
    e.stopPropagation();
    const rect = e.currentTarget.getBoundingClientRect();
    setFilterSearch("");
    setOpenTableFilter((prev) => (prev === key ? null : key));
    setFilterMenuPos((prev) => (
      openTableFilter === key && prev
        ? null
        : { top: rect.bottom + 6, left: rect.left, width: Math.max(rect.width, 230) }
    ));
  };

  const personelFilterOptions = useMemo(() => (
    Array.from(new Set(baseTableRows.map((r) => r.personName).filter(Boolean)))
      .sort((a, b) => a.localeCompare(b, "tr-TR"))
  ), [baseTableRows]);

  const setNumericFilter = (opKey, valueKey, op, value) => {
    setTableFilters((prev) => ({ ...prev, [opKey]: op, [valueKey]: value }));
  };

  const togglePersonelValue = (name) => {
    setTableFilters((prev) => {
      const current = prev.personelValues?.length ? prev.personelValues : personelFilterOptions;
      return {
        ...prev,
        personelValues: current.includes(name) ? current.filter((v) => v !== name) : [...current, name],
      };
    });
  };

  const setPersonelVisibleValues = (values, checked) => {
    setTableFilters((prev) => {
      const current = prev.personelValues?.length ? prev.personelValues : personelFilterOptions;
      return {
        ...prev,
        personelValues: checked
          ? Array.from(new Set([...current, ...values]))
          : current.filter((v) => !values.includes(v)),
      };
    });
  };

  const clearAllTableFilters = () => {
    setTableFilters({
      personel: "",
      personelValues: [],
      annualOp: "",
      annualValue: "",
      annualKalanOp: "",
      annualKalanValue: "",
      hakOp: "",
      hakValue: "",
      hakKalanOp: "",
      hakKalanValue: "",
      usedOp: "",
      usedValue: "",
      usedMonthOp: "",
      usedMonthValue: "",
      mahsupOp: "",
      mahsupValue: "",
      kesintiOp: "",
      kesintiValue: "",
    });
    setTableSort({ key: null, dir: null });
    setFilterSearch("");
  };

  /* =======================================
     RESMÃ�? TAT?L ?Å�?LEMLER? (Kurallar)
  ======================================= */
  const [manualHoliday, setManualHoliday] = useState("");
  const [manualHolidayList, setManualHolidayList] = useState([]);
  const [manualHolidayNote, setManualHolidayNote] = useState("");
  const [applyHolidayToPersons, setApplyHolidayToPersons] = useState(true);

  const addDateToHolidayList = () => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(manualHoliday)) return;
    setManualHolidayList((lst) => {
      const s = new Set(lst);
      s.add(manualHoliday);
      return Array.from(s).sort();
    });
    setManualHoliday("");
  };
  const clearHolidayList = () => setManualHolidayList([]);

  // C â†’ T uygula (yaln?z C olanlara), not opsiyonel
  const applyHolidayOnISO = async (iso, note) => {
    const y = +iso.slice(0, 4), m = +iso.slice(5, 7), d = +iso.slice(8, 10);
    const ym = ymmm(y, m);
    const snapP = await getDocs(collection(db, "personeller"));
    const allPersons = snapP.docs.map(docu => ({ id: docu.id, ...docu.data() }));
    const allow = new Set(allowedTesis.map(t=>String(t).toUpperCase()));
    const batch = writeBatch(db);
    const changed = [];

    for (const p of allPersons) {
      if (!allow.has(String(p.tesis||"").toUpperCase())) continue;
      if (!isActiveOnDate(p.tarih || {}, y, m, d)) continue;

      const key = `${p.id}_${ym}${pad2(d)}`;
      const statusNow =
        (y === year && m === month)
          ? (cells[key]?.status || "CALISMA")
          : (allByPidDate[p.id]?.[iso] || "CALISMA");

      if (statusNow === "CALISMA") {
        const ref = doc(db, "puantajV2", key);
        batch.set(ref, {
          personelId: p.id, date: iso, yyyymm: ym,
          status: "RESMI_TATIL",
          note: note || "",
          enteredBy: curUserRef(), enteredAt: new Date(),
        }, { merge: true });

        if (y === year && m === month) changed.push(key);
        setAllByPidDate((mm) => {
          const n = { ...mm };
          if (!n[p.id]) n[p.id] = {};
          n[p.id][iso] = "RESMI_TATIL";
          return n;
        });
      }
    }
    await batch.commit();
    if (changed.length) {
      setCells((prev) => {
        const next = { ...prev };
        for (const k of changed) next[k] = { status: "RESMI_TATIL", note: (manualHolidayNote || "") };
        return next;
      });
    }
  };

  // T â†’ C geri al ve NOTU S?L
  const revertHolidayOnISO = async (iso) => {
    const y = +iso.slice(0, 4), m = +iso.slice(5, 7), d = +iso.slice(8, 10);
    const ym = ymmm(y, m);
    const snap = await getDocs(query(collection(db, "puantajV2"), where("yyyymm", "==", ym)));
    const batch = writeBatch(db);
    const changed = [];

    for (const docu of snap.docs) {
      const v = docu.data() || {};
      if (String(v.date) !== iso) continue;
      if (v.status !== "RESMI_TATIL") continue;

      const key = `${v.personelId}_${ym}${pad2(d)}`;
      batch.set(doc(db, "puantajV2", key), {
        status: "CALISMA",
        note: "",
        enteredBy: curUserRef(),
        enteredAt: new Date(),
      }, { merge: true });

      setAllByPidDate((mm) => {
        const n = { ...mm };
        if (!n[v.personelId]) n[v.personelId] = {};
        n[v.personelId][iso] = "CALISMA";
        return n;
      });
      if (y === year && m === month) changed.push(key);
    }
    await batch.commit();
    if (changed.length) {
      setCells((m) => {
        const next = { ...m };
        for (const k of changed) next[k] = { status: "CALISMA", note: "" };
        return next;
      });
    }
  };

  // Listeyi koleksiyona ekle + uygula
  const commitHolidayList = async () => {
    // G?r?n?rl?k denetimi art?k (isCreator||isAdminModule||isHR||isSiteManager) ile JSX'te
    if (!manualHolidayList.length) return;

    // Koleksiyona yaz
    const yearGroups = {};
    for (const iso of manualHolidayList) {
      const y = iso.slice(0, 4);
      if (!yearGroups[y]) yearGroups[y] = [];
      yearGroups[y].push(iso);
    }
    for (const [y, list] of Object.entries(yearGroups)) {
      const ref = doc(db, "resmiTatil", String(y));
      const cur = await getDoc(ref);
      const prev = cur.exists() ? (cur.data() || {}) : {};
      const prevNotes = prev.notes || {};
      const prevApply = prev.apply || {};

      const note = (manualHolidayNote || "").trim();
      const newNotes = { ...prevNotes };
      const newApply = { ...prevApply };
      for (const iso of list) {
        if (note) newNotes[iso] = note;
        newApply[iso] = !!applyHolidayToPersons;
      }

      await setDoc(ref, { updatedAt: new Date() }, { merge: true });
      for (const iso of list) await updateDoc(ref, { days: arrayUnion(iso) });
      await updateDoc(ref, { notes: newNotes, apply: newApply, updatedAt: new Date() });

      if (applyHolidayToPersons) {
        for (const iso of list) await applyHolidayOnISO(iso, note);
      }
    }

    await readHolidays();
    setManualHolidayList([]);
    setManualHolidayNote("");
  };

  /* ---- RT Düzelt/Sil ---- */
  const [editHolidayISO, setEditHolidayISO] = useState(null);
  const [editHolidayNewISO, setEditHolidayNewISO] = useState("");
  const [editHolidayNote, setEditHolidayNote] = useState("");
  const [editHolidayApply, setEditHolidayApply] = useState(true);

  const startEditHoliday = (iso) => {
    setEditHolidayISO(iso);
    setEditHolidayNewISO(iso);
    setEditHolidayNote(holidayNotes[iso] || "");
    setEditHolidayApply(holidayApplyMap[iso] === true);
  };
  const cancelEditHoliday = () => {
    setEditHolidayISO(null);
    setEditHolidayNewISO("");
    setEditHolidayNote("");
    setEditHolidayApply(true);
  };

  const saveEditHoliday = async () => {
    if (!editHolidayISO) return;
    if (!/^\d{4}-\d{2}-\d{2}$/.test(editHolidayNewISO)) return alert("Tarih ISO format?nda olmal?: YYYY-MM-DD");

    const oldISO = editHolidayISO;
    const newISO = editHolidayNewISO;
    const oldYear = oldISO.slice(0, 4);
    const newYear = newISO.slice(0, 4);

    const oldApplyWas = holidayApplyMap[oldISO] === true;
    const newApplyWill = editHolidayApply === true;

    // 1) Eski y?ldan sil
    const oldRef = doc(db, "resmiTatil", String(oldYear));
    const oldSnap = await getDoc(oldRef);
    const oldData = oldSnap.exists() ? (oldSnap.data() || {}) : {};
    const oldNotes = { ...(oldData.notes || {}) };
    const oldApply = { ...(oldData.apply || {}) };
    delete oldNotes[oldISO];
    delete oldApply[oldISO];

    await updateDoc(oldRef, { days: arrayRemove(oldISO) }).catch(async () => {
      const cur = (await getDoc(oldRef)).data() || {};
      const days = Array.from(new Set((cur.days || []).filter(x => x !== oldISO)));
      await setDoc(oldRef, { days }, { merge: true });
    });
    await updateDoc(oldRef, { notes: oldNotes, apply: oldApply, updatedAt: new Date() });

    // 2) Yeni y?la ekle
    const newRef = doc(db, "resmiTatil", String(newYear));
    const newSnap = await getDoc(newRef);
    const curNew = newSnap.exists() ? (newSnap.data() || {}) : {};
    const nextNotes = { ...(curNew.notes || {}) };
    const nextApply = { ...(curNew.apply || {}) };

    if ((editHolidayNote || "").trim() !== "") nextNotes[newISO] = (editHolidayNote || "").trim();
    nextApply[newISO] = !!newApplyWill;

    await setDoc(newRef, { updatedAt: new Date() }, { merge: true });
    await updateDoc(newRef, { days: arrayUnion(newISO) });
    await updateDoc(newRef, { notes: nextNotes, apply: nextApply, updatedAt: new Date() });

    // 3) Uygulama etkileri:
    if (oldApplyWas) await revertHolidayOnISO(oldISO); // Tâ†’C + not sil
    if (newApplyWill) await applyHolidayOnISO(newISO, editHolidayNote); // Câ†’T

    await readHolidays();
    cancelEditHoliday();
  };

  const deleteHoliday = async (iso) => {
    if (!window.confirm(`${iso} tarihli resm? tatil silinsin mi?`)) return;

    const y = iso.slice(0, 4);
    const ref = doc(db, "resmiTatil", String(y));
    const snap = await getDoc(ref);
    const data = snap.exists() ? (snap.data() || {}) : {};
    const notes = { ...(data.notes || {}) };
    const apply = { ...(data.apply || {}) };
    const wasApplied = apply[iso] === true;
    delete notes[iso];
    delete apply[iso];

    await updateDoc(ref, { days: arrayRemove(iso) }).catch(async () => {
      const cur = (await getDoc(ref)).data() || {};
      const days = Array.from(new Set((cur.days || []).filter(x => x !== iso)));
      await setDoc(ref, { days }, { merge: true });
    });
    await updateDoc(ref, { notes, apply, updatedAt: new Date() });

    if (wasApplied) {
      await revertHolidayOnISO(iso); // Tâ†’C + not sil
    }
    await readHolidays();
    if (editHolidayISO === iso) cancelEditHoliday();
  };

  /* ------------ YILLIK ?Z?N OVERRIDE MODAL ------------ */
  const [openAnnualModalFor, setOpenAnnualModalFor] = useState(null);
  const [annualNewValue, setAnnualNewValue] = useState("");

  const openAnnualEdit = (person, shownTotal) => {
    setOpenAnnualModalFor(person);
    setAnnualNewValue(String(shownTotal ?? ""));
  };
  const closeAnnualEdit = () => {
    setOpenAnnualModalFor(null);
    setAnnualNewValue("");
  };
  const saveAnnualEdit = async () => {
    const p = openAnnualModalFor;
    if (!p) return;
    const val = Number(annualNewValue);
    if (!Number.isFinite(val) || val < 0) {
      alert("Geçerli bir say? girin (0 veya ?zeri).");
      return;
    }
    const ref = doc(db, "izinAyar", p.id);
    const prev = annualOverrideMap[p.id] ?? null;
    await setDoc(ref, { annualOverride: val, updatedAt: new Date() }, { merge: true });
    await addDoc(collection(db, "izinAyarLogs"), {
      personelId: p.id,
      prev,
      next: val,
      by: curUserRef(),
      at: new Date()
    });
    setAnnualOverrideMap((m) => ({ ...m, [p.id]: val }));
    closeAnnualEdit();
  };

  const openBalanceEdit = (person) => {
    if (!canSpecialPuantaj) return;
    const current = getBalanceMovementForMonth(person.id);
    setOpenBalanceModalFor(person);
    setBalanceMahsupValue(current.mahsupGun ? String(current.mahsupGun) : "");
    setBalanceKesintiValue(current.kesintiGun ? String(current.kesintiGun) : "");
    setBalanceNote(current.note || "");
  };

  const closeBalanceEdit = () => {
    setOpenBalanceModalFor(null);
    setBalanceMahsupValue("");
    setBalanceKesintiValue("");
    setBalanceNote("");
  };

  const saveBalanceEdit = async () => {
    const p = openBalanceModalFor;
    if (!p) return;
    if (!canSpecialPuantaj) {
      alert("Mahsup ve kesinti mahsubu düzenleme yetkiniz yok.");
      return;
    }
    const mahsupGun = toDayNumber(balanceMahsupRef.current?.value ?? balanceMahsupValue);
    const kesintiGun = toDayNumber(balanceKesintiRef.current?.value ?? balanceKesintiValue);
    const payload = {
      personelId: p.id,
      yyyymm,
      mahsupGun,
      kesintiGun,
      note: (balanceNoteRef.current?.value || balanceNote || "").trim(),
      updatedBy: curUserRef(),
      updatedAt: new Date(),
    };
    await setDoc(doc(db, "puantajBakiyeHareketleri", `${p.id}_${yyyymm}`), payload, { merge: true });
    setBalanceMovements((prev) => ({
      ...prev,
      [p.id]: {
        ...(prev[p.id] || {}),
        [yyyymm]: { mahsupGun, kesintiGun, note: payload.note },
      },
    }));
    closeBalanceEdit();
  };

  /* ------------ EXCEL ------------ */
  const dateHeader = (y, m, d) => `${pad2(d)}.${pad2(m)}.${y}`;

  // Yard?mc?: bir ay için C say?s? (opsiyonel maxD ile bugünden sonras? hari?)
  const countMonthC = (p, y, m, maxD = daysInMonth(y, m)) => {
    let Ccnt = 0;
    const ym = ymmm(y, m);
    for (let d = 1; d <= maxD; d++) {
      if (!isActiveOnDate(p.tarih || {}, y, m, d)) continue;
      const iso = toISO(y, m, d);
      const st =
        (y === year && m === month)
          ? (cells[`${p.id}_${ym}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA"))
          : (allByPidDate[p.id]?.[iso] || "CALISMA");
      if (st === "CALISMA") Ccnt++;
    }
    return Ccnt;
  };

  // Yard?mc?: bir ay için C/?/T var m?? (ay sayfas?n? olu?turma kriteri)
  const monthHasWorkOrLeave = (p, y, m, maxD = daysInMonth(y, m)) => {
    const ym = ymmm(y, m);
    for (let d = 1; d <= maxD; d++) {
      if (!isActiveOnDate(p.tarih || {}, y, m, d)) continue;
      const iso = toISO(y, m, d);
      const st =
        (y === year && m === month)
          ? (cells[`${p.id}_${ym}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA"))
          : (allByPidDate[p.id]?.[iso] || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA"));
      if (st === "CALISMA" || st === "IZIN" || st === "MAHSUP" || st === "RESMI_TATIL") return true;
    }
    return false;
  };

  // Yard?mc?: son giri?ten bugüne kadar toplam C (y?ll?k/personel Özetleri için)
  const countTotalCFromHire = (p) => {
    const gi = lastGirisDate(p.tarih || {});
    if (!gi) return 0;
    let y = gi.getFullYear();
    let m = gi.getMonth() + 1;
    const now = new Date();
    const endY = now.getFullYear();
    const endM = now.getMonth() + 1;
    let total = 0;
    while (y < endY || (y === endY && m <= endM)) {
      const domM = daysInMonth(y, m);
      const maxD = (y === endY && m === endM) ? Math.min(domM, now.getDate()) : domM;
      total += countMonthC(p, y, m, maxD);
      [y, m] = incYM(y, m);
    }
    return total;
  };

  const exportExcelMonth = () => {
    const now = new Date();
    const isCurrent = (year === now.getFullYear() && month === (now.getMonth() + 1));
    const maxD = isCurrent ? Math.min(dom, now.getDate()) : dom;

    const rows = tableRows.map(({ p, s }) => {
      const cThisMonth = countMonthC(p, year, month, maxD);
      const row = {
        Tesis: String(p.tesis || "-"),
        "Ad Soyad": `${p.ad || ""} ${p.soyad || ""}`.trim(),
        "Hak/Kalan": `${s.hk.hak}/${s.hk.kalan}`,
        "Ham Kalan": s.hk.rawKalan,
        "Mahsup": s.balance.mahsupGun,
        "Kesilen Mahsup": s.balance.kesintiGun,
        "Fazla Mahsup": s.balance.fazlaMahsup,
        "Fazla Kesinti": s.balance.fazlaKesinti,
        "Kullanılan (Toplam/Bu Ay)": `${s.used.total}/${s.used.month}`,
        "Çalışma": cThisMonth,
      };
      for (let d = 1; d <= maxD; d++) {
        const key = `${p.id}_${yyyymm}${pad2(d)}`;
        let cell = SHORT.NA;
        if (isActiveOnDate(p.tarih || {}, year, month, d)) {
          const iso = toISO(year, month, d);
          const st = cells[key]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA");
          cell = SHORT[st] || "C";
        }
        row[dateHeader(year, month, d)] = cell;
      }
      return row;
    });
    const ws1 = XLSX.utils.json_to_sheet(rows);

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws1, `${ymLabel(year, month)}`);
    XLSX.writeFile(wb, `puantaj_${year}-${pad2(month)}.xlsx`);
  };

  const buildYearWorkbookForPersons = async (personsList) => {
    const wb = XLSX.utils.book_new();

    // === ?ZET SAYFASI: BU YIL (1 Ocak - bugün) ===
    const now = new Date();
    const isCurrentYear = (year === now.getFullYear());
    const lastMonth = isCurrentYear ? (now.getMonth() + 1) : 12;
    const lastDayOf = (y, m) => (isCurrentYear && y === year && m === lastMonth) ? Math.min(daysInMonth(y, m), now.getDate()) : daysInMonth(y, m);

    // Ki?i baz?nda: bu yılın C/?/Y/?/R/T, bu y?l kullanılan (?+T), seçili ay kullanılan (?+T),
    // ve bu yılın Hak/Kalan (Pazar + uygun RT) hesaplar?
    const summaryRows = personsList.map((p) => {
      const sBase = personSummary(p);

      let C=0, I=0, M=0, Y=0, U=0, R=0, T=0;
      let usedThisMonth = 0;

      const gi = lastGirisDate(p.tarih || {});
      const startY = year;
      const startM = 1;
      const giY = gi ? gi.getFullYear() : year;
      const giM = gi ? gi.getMonth()+1 : 1;
      const sy = Math.max(startY, giY);
      const sm = (sy === giY) ? Math.max(startM, giM) : startM;

      let sundays = 0;
      let rtEligible = 0;

      for (let m = 1; m <= lastMonth; m++) {
        const maxD = lastDayOf(year, m);
        for (let d = 1; d <= maxD; d++) {
          if (!isActiveOnDate(p.tarih || {}, year, m, d)) continue;
          const iso = toISO(year, m, d);

          const st =
            (m === month)
              ? (cells[`${p.id}_${ymmm(year, m)}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA"))
              : (allByPidDate[p.id]?.[iso] || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA"));

          if (st === "CALISMA") C++;
          else if (st === "IZIN") I++;
          else if (st === "MAHSUP") M++;
          else if (st === "YILLIK") Y++;
          else if (st === "UCRETSIZ") U++;
          else if (st === "RAPOR") R++;
          else if (st === "RESMI_TATIL") T++;

          if (m === month && (st === "IZIN" || st === "MAHSUP" || st === "RESMI_TATIL")) usedThisMonth++;

          const onOrAfterStart =
            (year > sy) || (year === sy && (m > sm || (m === sm && d >= 1)));
          if (onOrAfterStart) {
            if (isSunday(year, m, d)) {
              sundays++;
            } else {
              if (yearDays.includes(iso)) rtEligible++;
            }
          }
        }
      }

      const hakYil = sundays + rtEligible;
      const usedYearTotal = I + M + T;
      const rawKalanYil = hakYil - usedYearTotal;
      const balanceYil = applyBalanceMovements(rawKalanYil, p.id, ymmm(year, lastMonth));
      const kalanYil = balanceYil.kalan;

      return {
        "Tesis": String(p.tesis || "-"),
        "Ad Soyad": `${p.ad || ""} ${p.soyad || ""}`.trim(),
        "Yıllık (Toplam/Kalan)": `${sBase.annual.toplam}/${sBase.annual.kalan}`,
        "Hak/Kalan": `${hakYil}/${kalanYil}`,
        "Ham Kalan": rawKalanYil,
        "Mahsup Ödeme": balanceYil.mahsupGun,
        "Kesilen Mahsup": balanceYil.kesintiGun,
        "Fazla Mahsup": balanceYil.fazlaMahsup,
        "Fazla Kesinti": balanceYil.fazlaKesinti,
        "Kullanılan (Toplam/Bu Ay)": `${usedYearTotal}/${usedThisMonth}`,
        "Çalışma": C,
        "İzin": I, "Mahsup": M, "Yıllık": Y,
        "Ücretsiz": U, "Rapor": R, "Resmî Tatil": T
      };
    });

    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(summaryRows), "Özet");

    // === Ay sayfalar? (bugüne kadar) - C/?/T varsa sayfa olu?tur ===
    for (let m = 1; m <= lastMonth; m++) {
      const ym = ymmm(year, m);
      const snap = await getDocs(query(collection(db, "puantajV2"), where("yyyymm", "==", ym)));
      const map = {};
      snap.forEach((d) => {
        const v = d.data() || {};
        const pid = v.personelId, ym2 = v.yyyymm, dateStr = String(v.date || "");
        const dd = dateStr.slice(-2);
        if (pid && ym2 && /^\d{2}$/.test(dd)) map[`${pid}_${ym2}${dd}`] = { status: v.status, note: v.note || "" };
      });

      const domM = daysInMonth(year, m);
      const maxD = (isCurrentYear && m === lastMonth) ? Math.min(domM, now.getDate()) : domM;

      const monthRows = [];
      for (const p of personsList) {
        if (!monthHasWorkOrLeave(p, year, m, maxD)) continue;

        const row = {
          Tesis: String(p.tesis || "-"),
          "Ad Soyad": `${p.ad || ""} ${p.soyad || ""}`.trim(),
        };
        for (let d = 1; d <= maxD; d++) {
          let cell = SHORT.NA;
          if (isActiveOnDate(p.tarih || {}, year, m, d)) {
            const iso = toISO(year, m, d);
            const st = map[`${p.id}_${ym}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA");
            cell = SHORT[st] || "C";
          }
          row[`${pad2(d)}.${pad2(m)}.${year}`] = cell;
        }
        monthRows.push(row);
      }

      if (monthRows.length > 0) {
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(monthRows), `${pad2(m)}-${year}`);
      }
    }
    return wb;
  };

  const exportExcelYear = async () => {
    const wb = await buildYearWorkbookForPersons(persons);
    XLSX.writeFile(wb, `puantaj_yillik_${year}.xlsx`);
  };

  /* ------------ Seçili personeller - Excel (panel) ------------ */
  const groupedPersonOptions = useMemo(() => {
    const byTesis = new Map();
    for (const p of persons) {
      const t = String(p.tesis || "-");
      if (!byTesis.has(t)) byTesis.set(t, []);
      byTesis.get(t).push({ value: p.id, label: `${p.ad || ""} ${p.soyad || ""}`.trim() });
    }
    return Array.from(byTesis.entries()).map(([label, options]) => ({
      label,
      options: options.sort((a, b) => a.label.localeCompare(b.label, "tr", { sensitivity: "base" }))
    }));
  }, [persons]);
  const [selectedPersons, setSelectedPersons] = useState([]);

  const buildWorkbookForSinglePerson = async (p) => {
    const wb = XLSX.utils.book_new();

    // --- ?ZET (BU YIL: 1 Ocak - bugün) ---
    const now = new Date();
    const isCurrentYear = (year === now.getFullYear());
    const lastMonth = isCurrentYear ? (now.getMonth() + 1) : 12;
    const lastDayOf = (y, m) => (isCurrentYear && y === year && m === lastMonth) ? Math.min(daysInMonth(y, m), now.getDate()) : daysInMonth(y, m);

    const sAnnual = personSummary(p);

    let C=0, I=0, M=0, Y=0, U=0, R=0, T=0;
    let usedThisMonth = 0;

    const gi = lastGirisDate(p.tarih || {});
    const startY = year;
    const startM = 1;
    const giY = gi ? gi.getFullYear() : year;
    const giM = gi ? gi.getMonth()+1 : 1;
    const sy = Math.max(startY, giY);
    const sm = (sy === giY) ? Math.max(startM, giM) : startM;

    let sundays = 0;
    let rtEligible = 0;

    for (let m = 1; m <= lastMonth; m++) {
      const maxD = lastDayOf(year, m);
      for (let d = 1; d <= maxD; d++) {
        if (!isActiveOnDate(p.tarih || {}, year, m, d)) continue;
        const iso = toISO(year, m, d);

        const st =
          (m === month)
            ? (cells[`${p.id}_${ymmm(year, m)}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA"))
            : (allByPidDate[p.id]?.[iso] || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA"));

        if (st === "CALISMA") C++;
        else if (st === "IZIN") I++;
        else if (st === "MAHSUP") M++;
        else if (st === "YILLIK") Y++;
        else if (st === "UCRETSIZ") U++;
        else if (st === "RAPOR") R++;
        else if (st === "RESMI_TATIL") T++;

        if (m === month && (st === "IZIN" || st === "MAHSUP" || st === "RESMI_TATIL")) usedThisMonth++;

        const onOrAfterStart =
          (year > sy) || (year === sy && (m > sm || (m === sm && d >= 1)));
        if (onOrAfterStart) {
          if (isSunday(year, m, d)) {
            sundays++;
          } else {
            if (yearDays.includes(iso)) rtEligible++;
          }
        }
      }
    }

    const hakYil = sundays + rtEligible;
    const usedYearTotal = I + M + T;
    const rawKalanYil = hakYil - usedYearTotal;
    const balanceYil = applyBalanceMovements(rawKalanYil, p.id, ymmm(year, lastMonth));
    const kalanYil = balanceYil.kalan;

    const sum = [{
      Tesis: String(p.tesis || "-"),
      "Ad Soyad": `${p.ad || ""} ${p.soyad || ""}`.trim(),
      "Yıllık (Toplam/Kalan)": `${sAnnual.annual.toplam}/${sAnnual.annual.kalan}`,
      "Hak/Kalan": `${hakYil}/${kalanYil}`,
      "Ham Kalan": rawKalanYil,
      "Mahsup Ödeme": balanceYil.mahsupGun,
      "Kesilen Mahsup": balanceYil.kesintiGun,
      "Fazla Mahsup": balanceYil.fazlaMahsup,
      "Fazla Kesinti": balanceYil.fazlaKesinti,
      "Kullanılan (Toplam/Bu Ay)": `${usedYearTotal}/${usedThisMonth}`,
      "Çalışma": C,
      "İzin": I, "Mahsup": M, "Yıllık": Y,
      "Ücretsiz": U, "Rapor": R, "Resmî Tatil": T
    }];
    XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(sum), "Özet");

    // --- Ay sayfalar? ---
    const gi2 = lastGirisDate(p.tarih || {});
    if (gi2) {
      const startY2 = gi2.getFullYear();
      const startM2 = gi2.getMonth() + 1;
      const now2 = new Date();
      const endY = now2.getFullYear();
      const endM = now2.getMonth() + 1;

      let y = startY2, m = startM2;
      while (y < endY || (y === endY && m <= endM)) {
        const ym = ymmm(y, m);
        const snap = await getDocs(query(collection(db, "puantajV2"), where("yyyymm", "==", ym)));
        const map = {};
        snap.forEach((d) => {
          const v = d.data() || {};
          const pid = v.personelId, ym2 = v.yyyymm, dateStr = String(v.date || "");
          const dd = dateStr.slice(-2);
          if (pid && ym2 && /^\d{2}$/.test(dd)) map[`${pid}_${ym2}${dd}`] = { status: v.status, note: v.note || "" };
        });

        const domM = daysInMonth(y, m);
        const maxD = (y === endY && m === endM) ? Math.min(domM, now2.getDate()) : domM;

        const has = monthHasWorkOrLeave(p, y, m, maxD);
        if (!has) { [y, m] = incYM(y, m); continue; }

        const row = {
          Tesis: String(p.tesis || "-"),
          "Ad Soyad": `${p.ad || ""} ${p.soyad || ""}`.trim(),
        };
        for (let d = 1; d <= maxD; d++) {
          let cell = SHORT.NA;
          if (isActiveOnDate(p.tarih || {}, y, m, d)) {
            const iso = toISO(y, m, d);
            const st = map[`${p.id}_${ym}${pad2(d)}`]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA");
            cell = SHORT[st] || "C";
          }
          row[`${pad2(d)}.${pad2(m)}.${y}`] = cell;
        }
        XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet([row]), `${pad2(m)}-${y}`);

        [y, m] = incYM(y, m);
      }
    }
    return wb;
  };

  const exportSelectedAsSeparate = async () => {
    if (!selectedPersons?.length) return alert("En az bir personel seçin.");
    const chosen = persons.filter(p => selectedPersons.includes(p.id));
    if (chosen.length === 1) {
      const wb = await buildWorkbookForSinglePerson(chosen[0]);
      XLSX.writeFile(wb, `puantaj_${(chosen[0].ad || "")}_${(chosen[0].soyad || "")}.xlsx`);
      return;
    }
    const [{ default: JSZip }, { saveAs }] = await Promise.all([import("jszip"), import("file-saver")]);
    const zip = new JSZip();
    for (const p of chosen) {
      const wb = await buildWorkbookForSinglePerson(p);
      const ab = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const fname = `puantaj_${(p.ad || "")}_${(p.soyad || "")}.xlsx`;
      zip.file(fname, ab);
    }
    const blob = await zip.generateAsync({ type: "blob" });
    saveAs(blob, "puantaj_secili_personeller.zip");
  };

  /* ------------ UI ------------ */
  const goPrev = () => { let y = year, m = month - 1; if (m < 1) { m = 12; y--; } setYear(y); setMonth(m); };
  const goNext = () => { let y = year, m = month + 1; if (m > 12) { m = 1; y++; } setYear(y); setMonth(m); };

  const nowY = today.getFullYear();
  const nowM = today.getMonth() + 1;
  const operatorOptions = [
    ["", "Filtre yok"],
    [">", "Büyüktür"],
    [">=", "Büyük / eşit"],
    ["<", "Küçüktür"],
    ["<=", "Küçük / eşit"],
    ["=", "Eşittir"],
  ];
  const numericFilterMeta = {
    annual: { title: "Yıllık Toplam", sortKey: "annual", opKey: "annualOp", valueKey: "annualValue" },
    annualKalan: { title: "Yıllık Kalan", sortKey: "annualKalan", opKey: "annualKalanOp", valueKey: "annualKalanValue" },
    hak: { title: "Hak", sortKey: "hak", opKey: "hakOp", valueKey: "hakValue" },
    hakKalan: { title: "Kalan Hak", sortKey: "hakKalan", opKey: "hakKalanOp", valueKey: "hakKalanValue" },
    used: { title: "Kullanılan Toplam", sortKey: "used", opKey: "usedOp", valueKey: "usedValue" },
    usedMonth: { title: "Kullanılan Bu Ay", sortKey: "usedMonth", opKey: "usedMonthOp", valueKey: "usedMonthValue" },
    mahsup: { title: "Mahsup (M)", sortKey: "mahsup", opKey: "mahsupOp", valueKey: "mahsupValue" },
    kesinti: { title: "Kesilen Mahsup (K)", sortKey: "kesinti", opKey: "kesintiOp", valueKey: "kesintiValue" },
  };
  const renderFilterButton = (key) => (
    <button
      type="button"
      className={`filter-trigger ${openTableFilter === key ? "open" : ""} ${
        (key === "personel" && (tableFilters.personel || tableFilters.personelValues?.length)) ||
        (numericFilterMeta[key] && (tableFilters[numericFilterMeta[key].opKey] || tableFilters[numericFilterMeta[key].valueKey])) ||
        tableSort.key === key
          ? "active"
          : ""
      }`}
      onClick={(e) => toggleHeaderFilter(key, e)}
      title="Filtrele ve sırala"
    >
      ▾
    </button>
  );
  const visiblePersonelOptions = personelFilterOptions.filter((v) => normText(v).includes(normText(tableFilters.personel)));
  const sortButtonClass = (key) => (
    tableSort.key === key && tableSort.dir === "asc"
      ? "sort-toggle asc"
      : tableSort.key === key && tableSort.dir === "desc"
        ? "sort-toggle desc"
        : "sort-toggle"
  );
  const toggleSortCycle = (key, firstDir = "desc") => {
    setTableSort((prev) => {
      if (prev.key !== key) return { key, dir: firstDir };
      return { key, dir: prev.dir === "asc" ? "desc" : "asc" };
    });
  };
  const sortButtonLabel = (key, type = "numeric") => {
    if (type === "text") {
      return tableSort.key === key && tableSort.dir === "desc" ? "Z'den A'ya sırala" : "A'dan Z'ye sırala";
    }
    return tableSort.key === key && tableSort.dir === "asc" ? "Küçükten büyüğe sırala" : "Büyükten küçüğe sırala";
  };
  const clearNumericFilterAndSort = (meta) => {
    setNumericFilter(meta.opKey, meta.valueKey, "", "");
    setTableSort((prev) => (prev.key === meta.sortKey ? { key: null, dir: null } : prev));
  };

  return (
    <div style={{ padding: 12, fontFamily: 'system-ui,-apple-system,"Segoe UI",Roboto,Arial' }}>
     
      <style>{`
        .bar{ display:flex; gap:8px; align-items:center; flex-wrap:wrap; margin-bottom:8px; }
        .btn{ padding:6px 10px; border:1px solid #d1d5db; border-radius:8px; background:#fff; }
        button.btn{ cursor:pointer; }
        input.btn, select.btn, textarea.btn{ cursor:default; }
        .btn[disabled]{ opacity:0.6; cursor:not-allowed; }
        .table-wrap{ width:100%; overflow:auto; max-height: 75vh;}
        .table-shell{ position:relative; }
        .loading-overlay{ position:absolute; inset:0; z-index:45; display:flex; align-items:flex-start; justify-content:center; padding-top:72px; background:rgba(248,250,252,.64); backdrop-filter:blur(1px); pointer-events:none; }
        .loading-card{ display:flex; align-items:center; gap:10px; border:1px solid #cbd5e1; border-radius:10px; background:#fff; padding:10px 14px; box-shadow:0 10px 24px rgba(15,23,42,.16); color:#0f172a; font-size:13px; font-weight:600; }
        .spinner{ width:16px; height:16px; border:2px solid #bfdbfe; border-top-color:#2563eb; border-radius:50%; animation:spin .8s linear infinite; }
        @keyframes spin{ to{ transform:rotate(360deg); } }
        table{ width:max-content; border-collapse:collapse; font-size:11px; }
        th,td{ border:1px solid #e5e7eb; padding:4px; text-align:center; white-space:nowrap; }
        thead th{ background:#f8fafc; position:sticky; top:0; z-index:10; }
.sticky-left-0{
  position:sticky !important;
  left:0;
  z-index: 20;
  background:#fff7f7;
  box-shadow: inset -1px 0 0 #e5e7eb, inset 0 -1px 0 #e5e7eb;
  top: 0;
}
.sticky-left-1{
  position:sticky !important; 
  left:118px;
  z-index: 19;
  background:#fff7f7;
  box-shadow: inset -1px 0 0 #e5e7eb, inset 1px 0 0 #e5e7eb, inset 0 -1px 0 #e5e7eb;
  top: 0;
}
thead th.sticky-left-0{ z-index:32; top:0; background:#f8fafc; }
thead th.sticky-left-1{ z-index:31; top:0; background:#f8fafc; }
td{ background:#fff; }

.name{
  text-align:left; background:#fff7f7;
  white-space:normal;
  width:118px;
  min-width:118px;
  max-width:118px;
  box-sizing:border-box;
  overflow:hidden;
  overflow-wrap:anywhere;
  line-height:1.15;
  padding-right:4px;
}
.name > .label{
  display:-webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
        .meta{ background:#fff7f7; font-weight:600; min-width:120px; box-sizing:border-box; }
        .cell{ width:22px; min-width:22px; height:22px; line-height:20px; border-radius:6px; cursor:pointer; user-select:none; position:relative; }
        .C{ background:#eef2ff; } .İ{ background:#86efac; color:#064e3b; font-weight:700; } .M{ background:#f5d0fe; } .Ü{ background:#fde68a; } .R{ background:#fee2e2; } .T{ background:#e2e8f0; } .Y{ background:#bbf7d0; font-weight:700; }
        .NA{ background:#f3f4f6; color:#6b7280; cursor:default; }
        .cell.has-note::after{ content:""; position:absolute; right:2px; bottom:2px; width:5px; height:5px; background:#dc2626; border-radius:50%; }
        .dot{ width:12px; height:12px; border-radius:3px; display:inline-block; margin-right:4px; vertical-align:middle; }
        .totals{ background:#f1f5f9; border:1px solid #e5e7eb; padding:8px; border-radius:8px; margin-bottom:8px; display:flex; gap:12px; flex-wrap:wrap; font-size:12px; }
        .k{ display:flex; align-items:center; gap:6px; }
        .mini{ font-size:12px; color:#475569; }
        .panel{ border:1px dashed #cbd5e1; border-radius:8px; padding:8px; background:$f8fafc; }
        .cap{ display:block; line-height:1.05; font-weight:600; }
        .subcap{ display:block; font-size:11px; line-height:1.05; color:#64748b; font-weight:500; }
        .chip{ display:inline-flex; align-items:center; gap:6px; padding:4px 8px; border:1px solid #cbd5e1; border-radius:999px; background:#fff; }
        .chip .act{ border:none; background:#f1f5f9; padding:2px 6px; border-radius:6px; cursor:pointer; }
        .chip .act:hover{ background:#e2e8f0; }

        .modal-backdrop{ position:fixed; inset:0; background:rgba(0,0,0,0.35); display:flex; align-items:center; justify-content:center; z-index:50; }
        .modal{ background:#fff; border-radius:12px; padding:16px; min-width:320px; box-shadow:0 10px 30px rgba(0,0,0,0.15); }
        .balance-modal{ width:min(440px, calc(100vw - 32px)); padding:14px; }
        .balance-row{ display:grid; grid-template-columns:minmax(0, 1fr) 120px; gap:12px; align-items:center; margin-bottom:10px; }
        .balance-label{ font-weight:600; line-height:1.25; text-align:left; }
        .balance-label .hint{ display:block; font-weight:400; color:#64748b; font-size:11px; margin-top:2px; white-space:normal; }
        .balance-input{ width:100%; box-sizing:border-box; text-align:right; }
        .th-title{ display:inline-flex; align-items:center; gap:6px; justify-content:center; width:100%; }
        .filter-trigger{ width:22px; height:20px; border:1px solid #cbd5e1; border-radius:6px; background:linear-gradient(#fff,#f1f5f9); color:#334155; cursor:pointer; font-size:12px; line-height:16px; padding:0; box-shadow:0 1px 1px rgba(15,23,42,.08); }
        .filter-trigger:hover,.filter-trigger.open{ background:#dbeafe; border-color:#60a5fa; color:#1d4ed8; }
        .filter-trigger.active{ background:#bfdbfe; border-color:#3b82f6; color:#1e40af; }
        .filter-menu{ position:fixed; background:#fff; border:1px solid #cbd5e1; border-radius:8px; box-shadow:0 12px 28px rgba(15,23,42,.18); z-index:9999; font-size:12px; padding:10px; max-height:330px; overflow:auto; }
        .filter-menu .menu-title{ font-weight:700; margin-bottom:8px; color:#0f172a; }
        .filter-menu input,.filter-menu select{ width:100%; box-sizing:border-box; border:1px solid #cbd5e1; border-radius:6px; padding:5px 6px; font-size:12px; background:#fff; }
        .filter-menu input.no-spin::-webkit-outer-spin-button,.filter-menu input.no-spin::-webkit-inner-spin-button{ -webkit-appearance:none; margin:0; }
        .filter-menu input.no-spin{ appearance:textfield; -moz-appearance:textfield; }
        .filter-menu button{ border:1px solid #cbd5e1; background:#fff; border-radius:6px; padding:5px 6px; font-size:12px; cursor:pointer; }
        .filter-menu button:hover{ background:#f1f5f9; }
        .filter-actions{ display:grid; grid-template-columns:1fr; gap:6px; margin-bottom:8px; }
        .sort-toggle.asc{ background:#ffedd5; border-color:#fdba74; color:#9a3412; }
        .sort-toggle.desc{ background:#dbeafe; border-color:#93c5fd; color:#1e40af; }
        .check-list{ max-height:150px; overflow:auto; border-top:1px solid #e5e7eb; padding-top:6px; }
        .check-row{ display:flex; gap:6px; align-items:center; margin:4px 0; text-align:left; }
        .check-row input{ width:auto; }
        .numeric-filter{ display:grid; gap:8px; }
      `}</style>

      {/* Üst bar */}
      <div className="bar">
        <button className="btn" onClick={goPrev}>&lt;</button>
        <strong>{ymLabel(year, month)}</strong>
        <button className="btn" onClick={goNext}>&gt;</button>

        <select
          className="btn"
          value={`${year}-${pad2(month)}`}
          onChange={(e)=>{ const [y,m]=e.target.value.split("-").map(Number); setYear(y); setMonth(m); }}
        >
          {Array.from({length: 120}, (_,i)=>{
            const baseY = nowY - 9; // ~10 y?l geriye
            const yy = baseY + Math.floor(i/12);
            const mm = 1 + (i%12);
            // dropdown'da bugünden sonras? listelenmesin
            if (yy > nowY || (yy === nowY && mm > nowM)) return null;
            return <option key={`${yy}-${mm}`} value={`${yy}-${pad2(mm)}`}>{ymLabel(yy, mm)}</option>;
          })}
        </select>

        <button className="btn" onClick={exportExcelMonth}>Aylık Excel</button>
        <button className="btn" onClick={exportExcelYear}>Yıllık Excel</button>

        <label className="btn" style={{ marginLeft: "auto", background:"transparent", border:"none", padding:0 }}>
          <input type="checkbox" checked={showNotes} onChange={(e)=>setShowNotes(e.target.checked)} /> Açıklamaları göster
        </label>
        <label className="btn" style={{ background:"transparent", border:"none", padding:0 }}>
          <input type="checkbox" checked={includePassive} onChange={(e)=>setIncludePassive(e.target.checked)} /> Çıkanları da göster
        </label>
      </div>

      {/* Üst toplamlar */}
      <div className="totals">
        <div className="k" title="Çalışma günü"><span className="dot" style={{background:"#eef2ff"}}></span>Çalışma: <b>{topTotals.C}</b></div>
        <div className="k" title="İzin günü"><span className="dot" style={{background:"#86efac"}}></span>İzin: <b>{topTotals.I}</b></div>
        <div className="k" title="Kalan izin hakkına istinaden yapılan ödeme"><span className="dot" style={{background:"#a855f7"}}></span>Mahsup: <b>{topTotals.BM}</b></div>
        <div className="k" title="Kullanılan fazla izne istinaden yapılan kesinti"><span className="dot" style={{background:"#f97316"}}></span>Kesilen Mahsup: <b>{topTotals.BK}</b></div>
        <div className="k" title="Yıllık izin"><span className="dot" style={{background:"#bbf7d0"}}></span>Yıllık: <b>{topTotals.Y}</b></div>
        <div className="k" title="Ücretsiz izin"><span className="dot" style={{background:"#fde68a"}}></span>Ücretsiz: <b>{topTotals.U}</b></div>
        <div className="k" title="Rapor"><span className="dot" style={{background:"#fee2e2"}}></span>Rapor: <b>{topTotals.R}</b></div>
        <div className="k" title="Resmî tatil"><span className="dot" style={{background:"#e2e8f0"}}></span>Resmî Tatil: <b>{topTotals.T}</b></div>
      </div>

      {/* RESMÃ�? TAT?L Y?NET?M? - yetkili rollere a??k */}
      {(isCreator || isAdminModule || isHR || isSiteManager) && (
        <div className="panel" style={{ marginBottom: 10 }}>
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Resmî Tatil Yönetimi</div>

          <div className="bar" style={{ marginBottom: 6 }}>
            <input type="date" className="btn" value={manualHoliday} onChange={(e)=>setManualHoliday(e.target.value)} />
            <button className="btn" onClick={addDateToHolidayList}>Tarih ekle</button>
            <input
              type="text"
              className="btn"
              style={{ minWidth: 260 }}
              placeholder="Açıklama (isteğe bağlı, hepsi için)"
              value={manualHolidayNote}
              onChange={(e)=>setManualHolidayNote(e.target.value)}
            />
            <label className="btn" title="Eklenen resmî tatilleri personellere de uygula">
              <input type="checkbox" checked={applyHolidayToPersons} onChange={(e)=>setApplyHolidayToPersons(e.target.checked)} /> Personellere uygula
            </label>
            <button className="btn" onClick={commitHolidayList} disabled={!manualHolidayList.length}>Resmî Tatil Ekle</button>
            <button className="btn" onClick={clearHolidayList} disabled={!manualHolidayList.length}>Temizle</button>
          </div>

          <div className="mini" style={{display:"flex", gap:6, flexWrap:"wrap", alignItems:"center"}}>
            Seçilen tarihler: {manualHolidayList.length ? manualHolidayList.map(d=> <span key={d} className="chip">{d}</span>) : "-"}
          </div>

          <div className="mini" style={{marginTop:8}}>
            <div style={{fontWeight:600, marginBottom:4}}>{year} yılı kayıtlı tatiller:</div>
            <div style={{display:"flex", gap:6, flexWrap:"wrap"}}>
              {yearDays.length ? yearDays.sort().map(iso => (
                <span
                  key={iso}
                  className="chip"
                  title={(holidayNotes[iso] ? `${iso} (${holidayNotes[iso]})` : iso) + (holidayApplyMap[iso] ? " - Uygulanıyor" : " - Uygulanmıyor")}
                  onDoubleClick={()=>startEditHoliday(iso)}
                  style={{cursor:"pointer"}}
                >
                  {iso}{holidayNotes[iso] ? ` (${holidayNotes[iso]})` : ""}{holidayApplyMap[iso] ? " [✓]" : " [×]"}
                  <button className="act" onClick={()=>startEditHoliday(iso)} title="Düzelt">Düzelt</button>
                  <button className="act" onClick={()=>deleteHoliday(iso)} title="Sil">Sil</button>
                </span>
              )) : "-"}
            </div>
          </div>

          {editHolidayISO && (
            <div className="bar" style={{marginTop:10, alignItems:"flex-end"}}>
              <div className="mini" style={{marginRight:8}}>
                <div><b>Düzenlenen:</b> {editHolidayISO}</div>
              </div>
              <label>Yeni tarih:
                <input
                  type="date"
                  className="btn"
                  value={editHolidayNewISO}
                  onChange={(e)=>setEditHolidayNewISO(e.target.value)}
                  style={{marginLeft:6}}
                />
              </label>
              <label>Açıklama:
                <input
                  type="text"
                  className="btn"
                  placeholder="(boş bırakılırsa silinir/korunur)"
                  value={editHolidayNote}
                  onChange={(e)=>setEditHolidayNote(e.target.value)}
                  style={{minWidth:260, marginLeft:6}}
                />
              </label>
              <label className="btn" title="Personellere uygula">
                <input type="checkbox" checked={editHolidayApply} onChange={(e)=>setEditHolidayApply(e.target.checked)} /> Personellere uygula
              </label>
              <button className="btn" onClick={saveEditHoliday}>Kaydet</button>
              <button className="btn" onClick={cancelEditHoliday}>Vazgeç</button>
            </div>
          )}
        </div>
      )}

      {/* Seçili Personeller - Excel */}
      <div className="panel" style={{ marginBottom: 10 }}>
        <div style={{ fontWeight: 700, marginBottom: 6 }}>Seçili Personeller - Excel</div>
        <div className="bar" style={{ gap:12 }}>
          <div style={{ minWidth: 320, flex: 1 }}>
            <Select
              options={groupedPersonOptions}
              isSearchable
              isMulti
              closeMenuOnSelect={false}
              placeholder="Personel ara ve seç..."
              onChange={(arr)=> setSelectedPersons((arr||[]).map(o=>o.value))}
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
            />
          </div>
          <button className="btn" onClick={exportSelectedAsSeparate}>
            Seçili kişi(ler) için Excel (çok seçiliyse ZIP)
          </button>
        </div>
        <div className="mini">Not: Listede yalnızca <b>yetkin olan</b> personeller görünür.</div>
      </div>

<div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "15px", flexWrap: "wrap" }}>
  
  {/* ğŸ�?¯ YEN?: Tesis Seçim Dropdown */}
  <select 
    className="btn" 
    value={selectedTesis} 
    onChange={(e) => setSelectedTesis(e.target.value)}
    style={{ 
      padding: "5px 10px", 
      height: "38px", 
      border: "1px solid #cbd5e1", 
      borderRadius: "4px",
      minWidth: "180px",
      cursor: "pointer"
    }}
  >
    <option value="">Tüm Tesisler (Yetkili)</option>
    {allowedTesis.map((t, index) => (
      <option key={index} value={t}>
        {t}
      </option>
    ))}
  </select>
</div>

      <div className="table-shell">
        {personsLoading && (
          <div className="loading-overlay">
            <div className="loading-card">
              <span className="spinner"></span>
              Personel listesi yenileniyor...
            </div>
          </div>
        )}
        <div className="table-wrap">
          <table>
          
          <thead>
            <tr>
              <th className="name sticky-left-0">
                <span className="th-title"><span className="cap">Personel</span>{renderFilterButton("personel")}</span>
              </th>
              <th
                className="meta sticky-left-1"
                title="Yıllık toplam / kalan (Çift tıkla düzenle)"
                style={{cursor:"default"}}
              >
                <span className="cap">Yıllık</span>
                <span className="subcap">
                  Toplam {renderFilterButton("annual")} / Kalan {renderFilterButton("annualKalan")}
                </span>
              </th>
              <th className="meta">
                <span className="cap">Hak/Kalan</span>
                <span className="subcap">
                  Hak {renderFilterButton("hak")} / Kalan {renderFilterButton("hakKalan")}
                </span>
              </th>
              <th className="meta">
                <span className="cap">Kullanılan</span>
                <span className="subcap">
                  Toplam {renderFilterButton("used")} / Bu Ay {renderFilterButton("usedMonth")}
                </span>
              </th>
              <th className="meta" title="Mahsup: Kalan izin hakkına istinaden yapılan ödeme. Kesilen Mahsup: Kullanılan fazla izne istinaden yapılan kesinti.">
                <span className="cap">Bakiye</span>
                <span className="subcap">
                  M {renderFilterButton("mahsup")} / K {renderFilterButton("kesinti")}
                </span>
              </th>
              {days.map((d)=> <th key={d}>{d}</th>)}
            </tr>
          </thead>
          <tbody>
            {tableRows.map(({ p, s, currentAnnualShown, personName }) => {
              return (
                <tr key={p.id}>
                  <td className="name sticky-left-0">
                    <span className="label">{personName}</span>
                  </td>

                  <td
                    className="meta sticky-left-1"
                    title="Çift tıkla: Yıllık hak toplamını düzenle"
                    onDoubleClick={()=>openAnnualEdit(p, currentAnnualShown)}
                    style={{cursor:"zoom-in"}}
                  >
                    {currentAnnualShown}/{s.annual.kalan}
                  </td>

                  <td className="meta">{s.hk.hak}/{s.hk.kalan}</td>
                  <td className="meta">{s.used.total}/{s.used.month}</td>
                  <td
                    className="meta"
                    title={`M Girilen: ${s.balance.mahsupGun}, Etkili: ${s.balance.effectiveMahsup}, Fazla: ${s.balance.fazlaMahsup}. K Girilen: ${s.balance.kesintiGun}, Etkili: ${s.balance.effectiveKesinti}, Fazla: ${s.balance.fazlaKesinti}. Ham kalan: ${s.hk.rawKalan}, Net kalan: ${s.hk.kalan}.`}
                    onDoubleClick={() => openBalanceEdit(p)}
                    style={{ cursor: canSpecialPuantaj ? "zoom-in" : "default" }}
                  >
                    M:{s.balance.mahsupGun || 0} / K:{s.balance.kesintiGun || 0}
                  </td>

                  {days.map((d) => {
                    const iso = toISO(year, month, d);
                    const key = `${p.id}_${yyyymm}${pad2(d)}`;

                    // BURASI YEN?: Pazar kontrol?
  const pazarMi = isSunday(year, month, d);
  // Pazar ise a??k k?rm?z? arka plan rengi tan?ml?yoruz
const pazarStyle = pazarMi ? { background: "#fee2e2", borderLeft: "1px solid #fca5a5", borderRight: "1px solid #fca5a5" } : {}

// ... Üstteki pazarStyle tan?mlaman duruyor ...

if (!isActiveOnDate(p.tarih || {}, year, month, d)) {
  return (
    <td key={key} style={pazarStyle}>
      <div className={`cell NA`} title="Aktif değil">{SHORT.NA}</div>
    </td>
  );
}

// ... alttaki const st = ... diye devam eden kodlar?n ...

                    const st = cells[key]?.status || (holidayApplyMap[iso] ? "RESMI_TATIL" : "CALISMA");
                    const mergedNote =
                      (cells[key]?.note || "") ||
                      (st === "RESMI_TATIL" ? (holidayNotes[iso] || "") : "");
                    const label = SHORT[st] || "C";
                    const title = mergedNote ? `${TITLE[st]} - Not: ${mergedNote}` : TITLE[st];
                    return (

                      // BURAYA pazarStyle ekledik
    <td key={key} style={pazarStyle}>
      <div
        className={`cell ${label} ${mergedNote ? "has-note" : ""}`}
        title={title}
        onClick={() => toggleCell(p.id, d, p)}
      >
        {label}
      </div>
      {showNotes && (
        <textarea
          rows={1}
          className="btn"
          style={{ width:"100%", marginTop:4, fontSize:11, padding:3 }}
          placeholder="açıklama..."
          value={cells[key]?.note || ""}
          onChange={(e)=>onNoteChange(p.id, d, e.target.value)}
          title={cells[key]?.note ? cells[key]?.note : "Açıklama"}
        />
      )}
    </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
          
          </table>
        </div>
      </div>

      {openTableFilter && filterMenuPos && (
        <div
          ref={tableFilterMenuRef}
          className="filter-menu"
          style={{ top: filterMenuPos.top, left: filterMenuPos.left, width: filterMenuPos.width }}
        >
          {openTableFilter === "personel" ? (
            <>
              <div className="menu-title">Personel</div>
              <div className="filter-actions">
                <button
                  type="button"
                  className={sortButtonClass("personel")}
                  onClick={() => toggleSortCycle("personel", "asc")}
                >
                  {sortButtonLabel("personel", "text")}
                </button>
              </div>
              <input
                placeholder="Ara..."
                value={tableFilters.personel}
                onChange={(e) => updateTableFilter("personel", e.target.value)}
                style={{ marginBottom: 8 }}
              />
              <label className="check-row" style={{ fontWeight: 700 }}>
                <input
                  type="checkbox"
                  checked={visiblePersonelOptions.length > 0 && (tableFilters.personelValues?.length === 0 || visiblePersonelOptions.every((v) => tableFilters.personelValues?.includes(v)))}
                  onChange={(e) => setPersonelVisibleValues(visiblePersonelOptions, e.target.checked)}
                />
                Görünenleri seç / kaldır
              </label>
              <div className="check-list">
                {visiblePersonelOptions.map((name) => (
                  <label className="check-row" key={name}>
                    <input
                      type="checkbox"
                      checked={tableFilters.personelValues?.length === 0 || tableFilters.personelValues?.includes(name) || false}
                      onChange={() => togglePersonelValue(name)}
                    />
                    {name}
                  </label>
                ))}
              </div>
              <button
                type="button"
                onClick={clearAllTableFilters}
                style={{ width: "100%", marginTop: 8 }}
              >
                Tüm filtreleri temizle
              </button>
            </>
          ) : (
            (() => {
              const meta = numericFilterMeta[openTableFilter];
              if (!meta) return null;
              return (
                <div className="numeric-filter">
                  <div className="menu-title">{meta.title}</div>
                  <div className="filter-actions">
                    <button
                      type="button"
                      className={sortButtonClass(meta.sortKey)}
                      onClick={() => toggleSortCycle(meta.sortKey, "desc")}
                    >
                      {sortButtonLabel(meta.sortKey)}
                    </button>
                  </div>
                  <label>
                    Özel filtre
                    <select
                      value={tableFilters[meta.opKey]}
                      onChange={(e) => setNumericFilter(meta.opKey, meta.valueKey, e.target.value, tableFilters[meta.valueKey])}
                      style={{ marginTop: 4 }}
                    >
                      {operatorOptions.map(([value, label]) => <option key={value} value={value}>{label}</option>)}
                    </select>
                  </label>
                  <input
                    type="text"
                    inputMode="decimal"
                    className="no-spin"
                    value={tableFilters[meta.valueKey]}
                    onChange={(e) => setNumericFilter(meta.opKey, meta.valueKey, tableFilters[meta.opKey], e.target.value)}
                    placeholder="Değer"
                  />
                  <div className="filter-actions">
                    <button type="button" onClick={() => clearNumericFilterAndSort(meta)}>
                      Temizle
                    </button>
                  </div>
                </div>
              );
            })()
          )}
        </div>
      )}

      {/* Mahsup / Kesinti Mahsubu Modal */}
      {openBalanceModalFor && (
        <div className="modal-backdrop" onClick={(e)=>{ if(e.target.classList.contains("modal-backdrop")) closeBalanceEdit(); }}>
          <div className="modal balance-modal" role="dialog" aria-modal="true">
            <div style={{fontWeight:700, marginBottom:8}}>Mahsup / Kesilen Mahsup</div>
            <div className="mini" style={{marginBottom:10}}>
              {openBalanceModalFor.ad} {openBalanceModalFor.soyad} - {ymLabel(year, month)}
            </div>
            <div className="balance-row" title="Kalan izin hakkina istinaden yapilan odeme">
              <div className="balance-label">
                Mahsup (M)
                <span className="hint">Kalan izin hakkina istinaden yapilan odeme</span>
              </div>
              <input
                type="number"
                className="btn balance-input"
                ref={balanceMahsupRef}
                defaultValue={balanceMahsupValue}
                min={0}
                step="1"
              />
            </div>
            <div className="balance-row" title="Kullanilan fazla izne istinaden yapilan kesinti">
              <div className="balance-label">
                Kesilen Mahsup (K)
                <span className="hint">Kullanilan fazla izne istinaden yapilan kesinti</span>
              </div>
              <input
                type="number"
                className="btn balance-input"
                ref={balanceKesintiRef}
                defaultValue={balanceKesintiValue}
                min={0}
                step="1"
              />
            </div>
            <label style={{display:"block", marginBottom:10}}>
              Açıklama:
              <textarea
                rows={2}
                className="btn"
                ref={balanceNoteRef}
                defaultValue={balanceNote}
                style={{display:"block", width:"100%", boxSizing:"border-box", marginTop:6}}
                placeholder="Örn. Kullanılan fazla izne istinaden yapılan kesinti"
              />
            </label>
            <div style={{display:"flex", gap:8, justifyContent:"flex-end"}}>
              <button className="btn" onClick={closeBalanceEdit}>Vazgeç</button>
              <button className="btn" onClick={saveBalanceEdit}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {/* Yıllık İzin Override Modal */}
      {openAnnualModalFor && (
        <div className="modal-backdrop" onClick={(e)=>{ if(e.target.classList.contains("modal-backdrop")) closeAnnualEdit(); }}>
          <div className="modal" role="dialog" aria-modal="true">
            <div style={{fontWeight:700, marginBottom:8}}>Yıllık Hak Düzelt</div>
            <div className="mini" style={{marginBottom:10}}>
              {openAnnualModalFor.ad} {openAnnualModalFor.soyad} - Tesis: {String(openAnnualModalFor.tesis||"-")}
            </div>
            <label style={{display:"block", marginBottom:10}}>
              Toplam Yıllık Hak (gün):
              <input
                type="number"
                className="btn"
                value={annualNewValue}
                onChange={(e)=>setAnnualNewValue(e.target.value)}
                style={{marginLeft:8, width:120}}
                min={0}
              />
            </label>
            <div style={{display:"flex", gap:8, justifyContent:"flex-end"}}>
              <button className="btn" onClick={closeAnnualEdit}>Vazgeç</button>
              <button className="btn" onClick={saveAnnualEdit}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PuantajPage;
